// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4421":"d2e33814","5696":"da0d64fa"}[chunkId] + ".chunk.css";
};